var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "od-carousel__wrapper" }, [
    _c("div", { staticClass: "od-carousel__container" }, [
      _c(
        "div",
        { ref: "swiper", staticClass: "swiper-container od-carousel" },
        [
          _vm.itemList.length
            ? _c(
                "div",
                { staticClass: "swiper-wrapper od-carousel__swiper-wrapper" },
                _vm._l(_vm.itemList, function(item) {
                  return _c(
                    "div",
                    { staticClass: "swiper-slide" },
                    [
                      _c(
                        "category-item",
                        {
                          attrs: {
                            "item-data": item.data,
                            "decimal-count": 0,
                            "disable-carousel-on-mobile":
                              _vm.itemList.length > _vm.itemsPerPage
                          }
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "small",
                              attrs: {
                                href: _vm._f("itemURL")(item.data, false),
                                title: _vm._f("itemName")(item.data)
                              }
                            },
                            [
                              _c("i", { staticClass: "fa fa-image" }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm._f("itemName")(item.data)))
                              ])
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "swiper-pagination od-carousel__pagination"
          })
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }